
import { lazy } from 'react';

export const LazyBudgets = lazy(() => 
  import('@/pages/Budgets').then(module => ({ default: module.Budgets }))
);
